import { createContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPopularSectors } from "../actions/sector/sectorActions";

const SectorsContext = createContext({});
export const SectorsContextProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { loading: sectorPopularLoading, data: sectorPopularData } =
    useSelector((state) => state.sectorPopularReducer);
  // const { popularSectors } = useSelector((state) => state.homeReducer);
  // const [sectorsData, setSectorsData] = useState([]);
  // const location = useLocation();
  // const [page_location, setPageLocation] = useState("");

  useEffect(() => {
    dispatch(getPopularSectors());
  }, []);

  // useEffect(() => {
  //   let pathname = location.pathname.split("/");
  //   if (pathname.length === 1) {
  //     setPageLocation(pathname[pathname.length - 1]);
  //   } else {
  //     setPageLocation("");
  //   }
  // }, [location.pathname]);

  // useEffect(() => {
  //   if (popularSectors?.data && popularSectors.data.length > 0) {
  //     var sortedSectors = popularSectors.data
  //       ?.slice()
  //       .sort((a, b) => b.totalClients - a.totalClients);
  //     setSectorsData(sortedSectors);
  //     dispatch(
  //       setCurrentIndustry({
  //         industryId: sortedSectors[0].id,
  //         sectorName: sortedSectors[0].sector,
  //         totalClients: sortedSectors[0].totalClients,
  //       })
  //     );
  //   }
  // }, [popularSectors.data, dispatch]);

  return (
    <SectorsContext.Provider
      value={{
        sectorPopularLoading,
        sectorPopularData,
      }}
    >
      {children}
    </SectorsContext.Provider>
  );
};

export default SectorsContext;
